import React from 'react';
import PropTypes from 'prop-types';
import { ListRow } from 'bv-components';

const Link = ({ link }) => (
  <ListRow
    to={`/pages/${link.path}`}
    label={link.title}
    hasArrow
  />
);

Link.propTypes = {
  link: PropTypes.instanceOf(Object).isRequired,
};

export default Link;
